import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tabs', 'tab', 'panel']
  static values = { name: String }

  connect() {
    this.selectDefaultTab()
  }

  handleTabClick(event) {
    this.selectTab(event.currentTarget)
  }

  selectTab(tab) {
    const panels = this.panelTargetsForGroup()
    const tabs = this.tabsTargetForGroup()
    if (!panels || !tabs) return

    const panel = panels.find(p => p.dataset.panel === tab.dataset.panel)
    if (!panel) return

    const activeTab = this.tabTargetsForGroup().find(t => t.classList.contains('is-active'))
    if (activeTab) {
      const activePanel = panels.find(p => p.dataset.panel === activeTab.dataset.panel)
      if (activePanel) {
        activeTab.classList.remove('is-active')
        activePanel.classList.remove('is-active')
      }
    }

    tab.classList.add('is-active')
    panel.classList.add('is-active')
    this.dispatch('tab-selected', { detail: { panel: tab.dataset.panel }, bubbles: true })
  }

  selectTabByPanel(event) {
    const tab = this.tabTargetsForGroup().find(t => t.dataset.panel === event.detail.panel)
    if (tab) this.selectTab(tab)
  }

  selectDefaultTab(activeGroupId = null) {
    if (activeGroupId) {
      const groupTab = this.tabTargetsForGroup().find(t => t.dataset.groupId === activeGroupId)
      if (groupTab) {
        this.selectTab(groupTab)
        return
      }
    }

    const selectedTab = this.tabTargetsForGroup().find(t => t.classList.contains('is-active'))
    if (selectedTab) {
      const activePanel = this.panelTargetsForGroup().find(p => p.dataset.panel === selectedTab.dataset.panel)
      if (activePanel) activePanel.classList.add('is-active')
      return
    }

    const firstTab = this.tabTargetsForGroup()[0]
    if (firstTab) this.selectTab(firstTab)
  }

  tabsTargetForGroup() {
    return this.tabsTargets.find(n => n.dataset.tabGroupName === this.nameValue)
  }

  tabTargetsForGroup() {
    return this.tabTargets.filter(n => n.dataset.tabGroupName === this.nameValue)
  }

  panelTargetsForGroup() {
    return this.panelTargets.filter(n => n.dataset.tabGroupName === this.nameValue)
  }
}
